// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueMoment from 'vue-moment'
import VueResource from 'vue-resource'
import VueClipboards from 'vue-clipboards'

import store from './store/index'
import router from './router'

import Buefy from 'buefy'
import '@/scss/main.scss'

Vue.config.productionTip = false

Vue.use(Buefy)
Vue.use(VueMoment)
Vue.use(VueResource)
Vue.use(VueClipboards)

Vue.http.interceptors.push((request, next) => {
  const token = sessionStorage.getItem('token')

  if (token) {
    // Add JWT to all requests
    request.headers.set('Authorization', 'Bearer: ' + token)

    // Add custom role-header
    if (store && store.state.user.data) {
      const { role } = store.state.user.data
      request.headers.set('X-IMA-Role', String(role))
    }
  }

  next(response => {
    if (response.status !== 200) {
      if (response.data) {
        if (Array.isArray(response.data)) {
          response.data.forEach(error => {
            store.commit('addError', error)
          })
        } else {
          store.commit('addError', response.data.error)
        }
      } else {
        store.commit('addError', {
          message: 'Es konnte keine Verbindung zum Server hergestellt werden'
        })
      }
    }
  })
})

Vue.http.options.root = '/'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js